/**
 * Where a sign-up started. A showroom stamps this when it opens the sign-up
 * modal for an anonymous visitor; the completed sign-up (LoginState) takes it
 * and puts it on the `signup` event, so sign-ups can be attributed to a
 * showroom. sessionStorage, not memory: a provider sign-in can round-trip
 * the tab. No dependencies — LoginState imports this.
 */

export interface SignupOrigin {
  origin: "showroom";
  supplier_id?: string;
  reason?: string;
}

const KEY = "showroomSignupOrigin";

export const rememberSignupOrigin = (origin: SignupOrigin) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(origin));
  } catch {
    /* private mode / blocked storage: attribution is best effort */
  }
};

/** Read and clear, so a later unrelated sign-up is not attributed. */
export const takeSignupOrigin = (): SignupOrigin | null => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    const parsed = JSON.parse(raw);
    return parsed?.origin === "showroom" ? (parsed as SignupOrigin) : null;
  } catch {
    return null;
  }
};
